import { configureStore, combineReducers } from "@reduxjs/toolkit";
import themeModeReducer from "./slices/themeModeSlice";
import authReducer from "./slices/authSlice";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const rootReducer = combineReducers({
  themeMode: themeModeReducer,
  auth: authReducer,
});

const persistConfig = { key: "root", storage, version: 1, blacklist: ["auth"] };
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: false,
});
